import React from 'react'
import cs from 'classnames'

interface ToolbarButtonProps {
  active?: boolean
  disabled?: boolean
  title: string
  onClick?: () => void
  icon: React.ReactNode
  testid?: string
}

const getToolbarButtonClassName = ({ disabled, active }: { disabled?: boolean, active?: boolean }) => {
  const base = cs(
    'relative',
    'px1',
    'height-100',
    'pointer',
    'flex',
    'flex-column',
    'justify-center',
    'items-center',
    'ease-in-out',
    'bg-white-10-hover'
  )

  return cs(base, {
    'c-white-25 fill-white-25 pointer-disabled': disabled,
    'c-primary fill-primary bg-white-10': !disabled && active,
    'c-white fill-white bg-white-10-hover': !disabled && !active
  })
}

function ToolbarButton (props: ToolbarButtonProps) {
  return (
    <div
      onClick={props.disabled ? () => {} : props.onClick}
      data-testid={props.testid || 'ToolBarBtn'}
      className={getToolbarButtonClassName({ disabled: props.disabled, active: props.active })}>
      {props.icon}
      <div className="f8 width-100 center mt1">{props.title}</div>
    </div>
  )
}

export default ToolbarButton
